import { useHouseholdInsightsData } from '../../data/hooks/useHouseholdInsightsData';
import { parseHouseholdProfile } from '../../data/parsers/parseHouseholdProfile';
import { InsightsMetricList } from '../InsightsMetricList/InsightsMetricList';

export const HouseholdProfile = () => {
  const { data, isLoading } = useHouseholdInsightsData(parseHouseholdProfile);

  return <InsightsMetricList title="Household Profile" unitLabel="households" items={data} isLoading={isLoading} />;
};
